import {useTranslation} from 'react-i18next';
import {Authorize} from '@postinumero/authorization';
import Page from '../../Page';
import Layout from "./Layout";

export default function Invoice() {
  const [t] = useTranslation();
  return (
    <Page title={t("invoices.pageTitle")}>
      <Authorize allow={['Issuer agent', 'Account operator', 'Inspector']}>
        <Layout/>
      </Authorize>
    </Page>
  );
}
